import styled, { css } from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledSegmentsRow = styled.div<{
  $hasEndIcon?: boolean;
  $hasLabel?: boolean;
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
  background: transparent;
  padding: ${({ $hasLabel }) => ($hasLabel ? "18px 12px 6px" : "0 12px")};
  padding-right: ${({ $hasEndIcon }) => ($hasEndIcon ? "0" : "12px")};
  cursor: text;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  user-select: none;
`;

export const StyledSegment = styled.span<{ $active: boolean; $empty: boolean }>`
  display: inline-block;
  min-width: 20px;
  text-align: center;
  padding: 1px 2px;
  border-radius: ${theme.variables.border_radius_5};
  outline: none;
  font-size: ${theme.variables.fs_14};
  color: ${({ $empty }) => ($empty ? theme.colors.grey_3 : theme.colors.black)};

  ${({ $active }) =>
    $active &&
    css`
      background: ${theme.colors.purple_2};
      color: ${theme.colors.purple};
    `}
`;

export const StyledSeparator = styled.span`
  color: ${theme.colors.grey_3};
  padding: 0 1px;
  pointer-events: none;
  font-size: ${theme.variables.fs_14};
`;
